import { useQuery } from '@tanstack/react-query';
import { acquireGraphToken } from '@/config/auth';

async function fetchUserPhoto(userId: string): Promise<string | null> {
  const token = await acquireGraphToken();
  if (!token) return null;

  const url = `https://graph.microsoft.com/v1.0/users/${encodeURIComponent(userId)}/photos/96x96/$value`;
  const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });

  if (!response.ok) return null;

  const blob = await response.blob();
  return URL.createObjectURL(blob);
}

export function useUserPhoto(userId: string | undefined) {
  return useQuery({
    queryKey: ['userPhoto', userId],
    queryFn: () => fetchUserPhoto(userId!),
    enabled: !!userId,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  });
}
